import React from 'react'
import CartLayout from 'src/components/cart/CartLayout'
import ProgressBarView from 'src/components/cart/ProgressBarView'
import Widget from 'src/components/cart/Widget'

const CartWidget = () => {
  return (
    <CartLayout title='Widget' previewComponent={<ProgressBarView />}>
      <Widget />
    </CartLayout>
  )
}

export default CartWidget
